import { useTranslation } from 'react-i18next'
import { getSiteRevampContent } from './siteRevampContent'

const useSiteRevampContent = () => {
  const { i18n } = useTranslation()
  return getSiteRevampContent(i18n.language)
}

export default useSiteRevampContent
